<template>
    <div class="banner-trabalhe banner wow animate__animated animate__fadeInRightBig">
        <h1>Entre Para o nosso Time</h1>
    </div>
    <div class="container py-5">
        <div class="row wow animate__animated animate__fadeInLeftBig">
            <div class="col-sm-12 col-md-8 col-lg-8">
                <p>No Fresto, nossa receita de sucesso vai além dos ingredientes. Acreditamos que o sabor especial de cada prato começa com pessoas apaixonadas pelo que fazem. Se você tem amor pela gastronomia e quer trabalhar em um ambiente onde a qualidade e o cuidado com cada detalhe fazem a diferença, venha fazer parte da nossa equipe!</p>
                
                <p>É fácil entrar em contato com a gente. Mande uma mensagem pelo <b><a href="https://api.whatsapp.com/send?phone=5511917517116" target="_blank">WhatsApp</a></b> ou envie um <b><a href="mailto:selecao@frestofood.com.br">e-mail</a></b>. Queremos saber um pouco mais sobre você e como podemos trabalhar juntos para criar momentos especiais para nossos clientes. Estamos esperando por você!</p>

                <hr>

                <div class="clique-aqui">
                    <h3 class="text-center">Para trabalhar conosco</h3>
                    <a href="https://api.whatsapp.com/send?phone=5511917517116" target="_blank">
                        <img src="../assets/img/clique-aqui.png" class="d-block m-auto" width="280" alt="">
                    </a>
                </div>

                <h3>Ou, se preferir, preencha os dados abaixo:</h3>

                        <form id="submit" action="#" class="mb-4">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-floating mb-3">
                                        <input type="text" class="form-control" id="nome" placeholder="Nome Completo">
                                        <label for="nome">Nome</label>
                                    </div>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-floating mb-3">
                                        <input type="email" class="form-control" id="email" placeholder="name@example.com">
                                        <label for="email">E-mail</label>
                                    </div>
                                </div>

                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-floating mb-3">
                                        <input type="tel" class="form-control" id="tel" placeholder="(99) 99999-9999">
                                        <label for="tel">Telefone</label>
                                    </div>
                                </div>
                            </div>

                            

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-floating mb-3">
                                        <input type="file" class="form-control" id="floatingFile" placeholder="Enviar CV">
                                        <label for="floatingTextarea">Enviar CV</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="btn-row">
                                        

                                        <button id="btn-reset" type="reset" class="btn btn-lg btn-outline-primary">Limpar</button>
                                        <button id="btn-submit" type="submit" class="btn btn-lg btn-primary">Enviar</button>                                        
                                    </div>                                    
                                </div>
                            </div> 
                        </form> 


            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
                <img src="../assets/img/trabalhe-01.webp" class="w-100 rounded-2" alt="">
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'TrabalheConosco'
};
</script>

